import { render, staticRenderFns } from "./PurposeStats.vue?vue&type=template&id=9477db66&scoped=true&"
var script = {}
import style0 from "./PurposeStats.vue?vue&type=style&index=0&id=9477db66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9477db66",
  null
  
)

export default component.exports